import _ from 'lodash';
import React, {Component} from 'react';
import styles from './Timeout.module.scss';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';
import {allPoses, wrongAnswerTimeoutPoses} from '../gameHelpers';

const Container = posed.div({
    ...keysToSingleValue(wrongAnswerTimeoutPoses, {
        y: 0,
        transition: {
            ease: 'easeOut',
            duration: 1000,
        },
    }),
    ...keysToSingleValue(_.difference(allPoses, wrongAnswerTimeoutPoses), {
        y: '50vh',
        transition: {
            ease: 'easeIn',
            duration: 1000,
        },
    }),
});

export default function Timeout() {
    return <Container className={styles.timeout}>Time's up!</Container>;
}
